import axios from '../axios'

export default class ViewDatailsOsContractServices {
    async getOsByContract(contratc_number){
        let res = await axios.get("Contract/GetOsByContract?contractNumber="+contratc_number);
        return res.data;
    }

    async updatedOsStatus(os_data){
        let res = await axios.put("/Contract/UpdateMyHistory", os_data);
        return res.data;
    }
    
}